export const PROGRAM_ERROR = 'PROGRAM_ERROR';
export const PROGRAM_LOADING = 'PROGRAM_LOADING';
export const PROGRAM_GET = 'PROGRAM_GET';
